/**
 * A wrapper to handle the Modern pagination style, and infinite scroll.
 *
 * Usage:
 *  {%- if settings.pagination_style == "modern" or settings.pagination_infinite -%}
 *    <script src="{{ 'custom-pagination.js' | asset_url }}" defer="defer"></script>
 *  {%- endif -%}
 *
 *  {%- paginate thing by stuff -%}
 *    <custom-pagination data-infinite-scroll="{{ settings.pagination_infinite }}"
 *      data-pause-infinite-scroll="false">
 *      <ul>
 *        <li class="js-pagination-result">One</li>
 *        <li class="js-pagination-result">Two</li>
 *        <li class="js-pagination-result">Three</li>
 *      </ul>
 *      {%- if paginate.pages > 1 -%}
 *        {% render 'pagination', paginate: paginate, style: settings.pagination_style %}
 *      {%- endif -%}
 *    </custom-pagination>
 *  {%- endpaginate -%}
 */
if (!customElements.get("custom-pagination")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.init(), document.addEventListener("on:bfcache:load-restore", this.reload.bind(
        this))
    }
    disconnectedCallback() {
      this.destroy()
    }
    init() {
      this.infiniteScroll = "true" === this.dataset.infiniteScroll, this.pagination = this
        .querySelector(".js-pagination"), this.loadMoreButton = this.querySelector(
          ".js-pagination-load-more"), this.results = this.querySelectorAll(
          ".js-pagination-result"), this.controller = null, this.resultClickHandler = this
        .resultClickHandler || this.handleResultClick.bind(this), this.addEventListener("click",
          this.resultClickHandler), this.loadMoreClickHandler = this.loadMoreClickHandler || this
        .handleLoadMoreClick.bind(this), this.pagination && this.pagination.dataset
        .isMoreResults && this.results && (this.loadMoreButton && this.loadMoreButton
          .addEventListener("click", this.loadMoreClickHandler), this.infiniteScroll && (this
            .paginationObserver = new IntersectionObserver(t => {
              t.forEach(t => {
                t.isIntersecting ? (this.loadMore(), this.intersectingTimer = setInterval(
                    this.loadMore.bind(this), 1e3)) : this.intersectingTimer &&
                  clearInterval(this.intersectingTimer)
              })
            }, {
              rootMargin: `${1.5*window.innerHeight}px 0px`
            }), this.paginationObserver.observe(this.pagination)))
    }
    destroy() {
      this.intersectingTimer && clearInterval(this.intersectingTimer), this.paginationObserver &&
        this.paginationObserver.disconnect(), this.loadMoreButton && this.loadMoreButton
        .removeEventListener("click", this.loadMoreClickHandler), this.removeEventListener(
          "click", this.resultClickHandler), this.loadMoreClickHandler = null
    }
    reload() {
      this.destroy(), this.init()
    }
    handleLoadMoreClick(t) {
      t.preventDefault(), this.loadMore()
    }
    handleResultClick(t) {
      t.target.closest("a") && t.target.closest(".js-pagination-result") && this.controller &&
        this.controller.abort()
    }
    async loadMore() {
      if (!this.isFetching && "false" === this.dataset.pauseInfiniteScroll) {
        this.isFetching = !0, this.controller = new AbortController;
        try {
          if (!this.loadMoreButton) throw Error("No 'Load more' button found.");
          this.loadMoreButton.classList.add("is-loading"), this.loadMoreButton.setAttribute(
              "aria-disabled", "true"), "traditional" === this.pagination.dataset
            .paginationStyle && this.pagination.classList.add("is-loading");
          let t = await fetch(this.loadMoreButton.href, {
            signal: this.controller.signal
          });
          if (!t.ok) throw Error(t.status);
          if ("true" === this.dataset.pauseInfiniteScroll) throw Error(
            "Infinite scroll was interrupted.");
          let i = document.createElement("template");
          i.innerHTML = await t.text();
          let e = "",
            s = this.results[this.results.length - 1];
          i.content.querySelectorAll(".js-pagination-result").forEach(t => {
              e += t.outerHTML
            }), s.insertAdjacentHTML("afterend", e), window.initLazyImages(), this.results = this
            .querySelectorAll(".js-pagination-result");
          let n = i.content.querySelector(".js-pagination");
          n.dataset.isMoreResults ? (this.pagination.innerHTML = n.innerHTML, this
            .loadMoreButton && (this.loadMoreButton.removeEventListener("click", this
              .loadMoreClickHandler), this.loadMoreButton = this.querySelector(
              ".js-pagination-load-more"), this.loadMoreButton.addEventListener("click", this
              .loadMoreClickHandler))) : (this.pagination.remove(), this.intersectingTimer &&
            clearInterval(this.intersectingTimer), this.paginationObserver && this
            .paginationObserver.disconnect(), document.querySelectorAll(
              ".js-when-paginated-only").forEach(t => t.remove()))
        } catch (o) {
          console.log("Unable to fetch next page of results", o), this.intersectingTimer &&
            clearInterval(this.intersectingTimer)
        } finally {
          this.controller = null, this.loadMoreButton && (this.loadMoreButton.classList.remove(
              "is-loading"), this.loadMoreButton.removeAttribute("aria-disabled")), this
            .isFetching = !1, "traditional" === this.pagination.dataset.paginationStyle && this
            .pagination.classList.remove("is-loading")
        }
      }
    }
  }
  customElements.define("custom-pagination", t)
}
